import { useMemo } from "react";
import { Link } from "react-router-dom";

import { DatabaseMetadataPopover } from "../../../../components/DatabaseMetadataPopover/DatabaseMetadataPopover.tsx";
import { ClikDataDetail } from "../../../../types/clikData/clikData.ts";
import { toHumanReadable } from "../../../../utils/string.ts";

interface Props {
  data: ClikDataDetail | null | undefined;
}

export const useClikDataCompanyInfoCards = ({ data }: Props) => {
  const companyInfo = useMemo(() => {
    return [
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikData",
              fieldName: "companyId",
            }}
            position="right"
          >
            Company Clik Result Name
          </DatabaseMetadataPopover>
        ),
        content: data?.company?.name,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "Customer",
              fieldName: "salesName",
            }}
            position="right"
          >
            Sales Name
          </DatabaseMetadataPopover>
        ),
        content: data?.company?.salesName,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "Customer",
              fieldName: "salesTeamName",
            }}
            position="right"
          >
            Sales Team
          </DatabaseMetadataPopover>
        ),
        content: data?.company?.salesTeamName,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "bussinessIdentifyNumber",
            }}
            position="right"
          >
            Business Identity Number
          </DatabaseMetadataPopover>
        ),
        content: data?.companyData?.bussinessIdentifyNumber,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "phone",
            }}
            position="right"
          >
            Phone Number
          </DatabaseMetadataPopover>
        ),
        content: data?.companyData?.phone && (
          <Link to={"tel:" + data?.companyData?.phone} target="_blank">
            {data?.companyData.phone}
          </Link>
        ),
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "npwpCompany",
            }}
            position="right"
          >
            NPWP company
          </DatabaseMetadataPopover>
        ),
        content: data?.companyData?.npwpCompany?.url && (
          <Link to={data?.companyData.npwpCompany.url} target="_blank">
            Download
          </Link>
        ),
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "Customer",
              fieldName: "sector",
            }}
            position="right"
          >
            Sector
          </DatabaseMetadataPopover>
        ),
        content: data?.company?.sector,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "Customer",
              fieldName: "subSector",
            }}
            position="right"
          >
            Subsector
          </DatabaseMetadataPopover>
        ),
        content: data?.company?.subSector,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "Customer",
              fieldName: "categoryL1",
            }}
            position="right"
          >
            Category L1
          </DatabaseMetadataPopover>
        ),
        content: data?.company?.categoryL1,
      },
    ];
  }, [data]);

  const companyAddress = useMemo(() => {
    return [
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "npwpAddress",
            }}
            position="right"
          >
            NPWP address
          </DatabaseMetadataPopover>
        ),
        content: data?.companyData?.npwpAddress,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "subDistrict",
            }}
            position="right"
          >
            Sub-district
          </DatabaseMetadataPopover>
        ),
        content: data?.companyData?.subDistrict,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "district",
            }}
            position="right"
          >
            District
          </DatabaseMetadataPopover>
        ),
        content: data?.companyData?.district,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "city",
            }}
            position="right"
          >
            City
          </DatabaseMetadataPopover>
        ),
        content: toHumanReadable(data?.companyData?.city.name),
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "postalCode",
            }}
            position="right"
          >
            Postal Code
          </DatabaseMetadataPopover>
        ),
        content: data?.companyData?.postalCode,
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "ClikCompanyData",
              fieldName: "country",
            }}
            position="right"
          >
            Country
          </DatabaseMetadataPopover>
        ),
        content:
          data?.companyData?.country?.name &&
          toHumanReadable(data?.companyData.country.name),
      },
    ];
  }, [data]);

  return [companyInfo, companyAddress];
};
